import React, { Component } from 'react';
import { connect } from 'react-redux';


class FacebookLikesBox extends Component {
    componentDidMount() {
        if(window.FB) {
            window.FB.XFBML.parse();
        }
      }

    render() {
        return (
            <div className="facebook-likes-box">
                <p>Ne găseşti şi pe Facebook!</p>
                <div id="fb-root"/>
                <div className="fb-page" data-href="https://www.facebook.com/revistacinemap" data-small-header="false"
                     data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true">
                    <blockquote cite="https://www.facebook.com/revistacinemap" className="fb-xfbml-parse-ignore"><a
                        href="https://www.facebook.com/revistacinemap">Cinemap</a></blockquote>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(FacebookLikesBox);



// WEBPACK FOOTER //
// ./src/FO/components/facebooklikesbox/facebooklikesbox.component.js